import {
    DocumentImage,
    DocumentImageGroup
} from '@containers/scalable-document-list/document-image';
import { getOverallDocumentType } from '@dtos/document-type';
import {
    groupBy,
    reduce,
    sortBy,
    keys
} from 'lodash';

const groupByOverallDocumentType = (documents: DocumentImage[]) => groupBy(documents, ({ type }) => getOverallDocumentType(type));

export const getOverallDocumentTypes = (documents: DocumentImage[]): string[] => {
    const groupedByOverallDocumentType = groupByOverallDocumentType(documents);
    return keys(groupedByOverallDocumentType);
};

export const groupByOverallTypeAndSortDocuments = (documents: DocumentImage[]): DocumentImageGroup[] => {
    const groupedByOverallDocumentType = groupByOverallDocumentType(documents);
    return reduce(groupedByOverallDocumentType, (
        sorted: DocumentImageGroup[],
        documentGroup: DocumentImage[],
        documentType: string
    ) => {
        const appended = [
            ...sorted,
            {
                type: documentType,
                // assumes that types with a back side have a longer type
                documents: sortBy(documentGroup, ({ type }) => type.length)
            }
        ];

        return sortBy(appended, ({ type }) => type);
    }, []);
};



// WEBPACK FOOTER //
// ./src/containers/scalable-document-list/document-grouping.ts